import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { createTimeClock } from '../../store/actions/timeClock';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import CreateTimeClockForm from '../../components/TimeClock/CreateTimeClockForm';

const styles = theme => ({
  container: {
    padding: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  inline: {
    margin: `0 ${theme.spacing(1)}px 0 0`,
    display: 'inline-block',
  },
});

const CreateTimeClock = ({
  classes, loading, onCreateTimeClock, match, location,
}) => (
  <React.Fragment>
    <ContentHeader
      title="Cadastrar Ponto"
      subtitle="Informe os dados para o cadastro de um ponto"
    />

    <Paper elevation={2} className={classes.container}>
      <Grid container justify="space-between" className={classes.header}>
        <Grid item>
          <Typography variant="body1" color="textSecondary" className={classes.inline}>
            Funcionário:
          </Typography>
          <Typography variant="body1" className={classes.inline}>
            {location.state ? location.state.name : null}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" color="textSecondary">{moment(match.params.date).format('LL')}</Typography>
        </Grid>
      </Grid>

      <CreateTimeClockForm
        loading={loading}
        employeeId={match.params.id}
        date={match.params.date}
        onCreateTimeClock={timeclock => onCreateTimeClock(timeclock)}
      />
    </Paper>
  </React.Fragment>
);

const mapStateToProps = state => ({
  loading: state.general.loading,
});

const mapDispatchToProps = dispatch => ({
  onCreateTimeClock: timeclock => dispatch(createTimeClock(timeclock)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CreateTimeClock));
